import Component from '@lightningjs/core/dist/src/application/Component.mjs';
import { Lightning } from '@lightningjs/sdk'
import { Base } from '@lightningjs/ui-components'

export default class TopCarouselMarker extends Lightning.Component {
    [x: string]: number;
    _progressAnim: any;

    static override _template(): Lightning.Component.Template {
        return {
            rect: true,
            color: 0xff808080,
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 10 },
            ProgressFill: {
                w: 0,
                h: (h: number) => h,
                rect: true,
                color: this.bindProp('progcolor'),
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 10 }
            }
        }
    }

    override _init() {
        this._progressAnim = this.tag('ProgressFill').animation({
            duration: 8,
            stopMethod: 'immediate',
            actions: [
                {
                    p: 'w',
                    v: { 0: 0, 1: 60 }
                }
            ]
        });
        this._progressAnim.on('finish', ()=>{
            this.fireAncestors('$next')
        })
    }

    override _focus(newFocusedComponent: Component | undefined, prevFocusedComponent: Component | undefined): void {
        this.w = 60
        setTimeout(()=>{
            //this._progressAnim.start()
            this.fireAncestors('$focusedItem', this.index)
        }, 16)
    }

    override _unfocus(newFocusedComponent: Component | undefined, prevFocusedComponent: Component | undefined): void {
        this._progressAnim.stop()
        this.w = 20        
    }
}
